<template>
	<c-form-item :label="label">
		<slot></slot>
	</c-form-item>
</template>

<script>
	export default {
		name: 'mSearchItem',
		
		props: {
			label: String
		}
	}
</script>

<style lang="stylus">
</style>
